module.exports = __webpack_public_path__ + "static/media/Rapport_mémoire_AREVA.2a0299f5.pdf";